import React from 'react'
import './Navbar.css'
import { useDispatch } from 'react-redux'
import { logoutAction } from '../../../utils/redux/auth/authActions';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            const response = await dispatch(logoutAction());
            if (response.success === true) {
                navigate('/login');
            }
        } catch (error) {
            console.log("Error in logging out: ", error);
        }
    }
    return (
        <div className='navbar px-3'>
            <div className='d-flex justify-content-between align-items-center'>
                <div className={`logo-container`}>
                    {/* <img src='Logo.png' alt='Tulio' height={50} width={150} /> */}
                </div>
            </div>
            <button
                className='btn btn-danger'
                style={{
                    cursor: 'pointer'
                }}
                onClick={handleLogout}
            >
                Logout
            </button>
        </div>
    )
}

export default Navbar